// src/ConsumerApp/Screens/ProductDetails/components/ProductOptionsModal.js

import React from 'react';
import X from '../../../../assets/icons/X.svg';
import ProductOptionCard from './ProductOptionCard';

export default function ProductOptionsModal({
  visible = false,
  onClose,
  cardTitle = 'Add To Buy',
  productData,
  onAddOption,
  bucketItemsMap,
  customerId,
  hubId,
  purchaseType = 'BUY_NOW',
}) {
  if (!visible) return null;

  const optionsList = Array.isArray(productData)
    ? productData
    : productData?.product_variants || [];
  const optionsCount = optionsList.length;

  return (
    <div className="bb-pdp-opt-overlay" onClick={onClose}>
      <style>{`
        .bb-pdp-opt-overlay {
          position: fixed;
          inset: 0;
          background-color: rgba(15, 23, 42, 0.58);
          z-index: 999999;
          display: flex;
          align-items: center;
          justify-content: center;
          backdrop-filter: blur(4px);
          padding: 16px;
          box-sizing: border-box;
        }

        .bb-pdp-opt-card {
          background-color: #FFFFFF;
          border-radius: 18px;
          padding: 20px 22px;
          width: 100%;
          max-width: 520px;
          display: flex;
          flex-direction: column;
          gap: 14px;
          max-height: 82vh;
          box-shadow: 0 24px 48px -12px rgba(0, 0, 0, 0.25);
          box-sizing: border-box;
          overflow: hidden;
        }

        .bb-pdp-drag-handle {
          display: none;
        }

        .bb-pdp-opt-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #F1F5F9;
          padding-bottom: 12px;
        }

        .bb-pdp-opt-list {
          display: flex;
          flex-direction: column;
          gap: 10px;
          overflow-y: auto;
          -webkit-overflow-scrolling: touch;
          padding-right: 2px;
        }

        /* ── Mobile Viewport: Bottom Sheet Layout (<= 640px) ── */
        @media (max-width: 640px) {
          .bb-pdp-opt-overlay {
            padding: 0;
            align-items: flex-end;
          }

          .bb-pdp-opt-card {
            max-width: 100vw;
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            border-top-left-radius: 22px;
            border-top-right-radius: 22px;
            max-height: 85vh;
            padding: 12px 18px 24px 18px;
            animation: slideUpOptions 0.22s cubic-bezier(0.16, 1, 0.3, 1);
          }

          @keyframes slideUpOptions {
            from { transform: translateY(100%); }
            to { transform: translateY(0); }
          }

          .bb-pdp-drag-handle {
            display: block;
            width: 42px;
            height: 4.5px;
            background-color: #CBD5E1;
            border-radius: 999px;
            margin: 0 auto 10px auto;
          }
        }
      `}</style>

      <div className="bb-pdp-opt-card" onClick={(e) => e.stopPropagation()}>
        {/* Mobile Swipe / Drag Pill Handle */}
        <div className="bb-pdp-drag-handle" />

        {/* Header */}
        <div className="bb-pdp-opt-header">
          <div>
            <h4 style={{ margin: 0, fontSize: 16, fontWeight: 800, color: '#0F172A' }}>{cardTitle}</h4>
            <span style={{ fontSize: 12, color: '#64748B', marginTop: 2, display: 'block' }}>
              {optionsCount} {optionsCount === 1 ? 'option available' : 'options available'}
            </span>
          </div>

          <button
            type="button"
            onClick={onClose}
            style={{
              background: '#F1F5F9',
              border: 'none',
              borderRadius: '50%',
              width: 30,
              height: 30,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'pointer',
            }}
          >
            <img src={X} alt="close" style={{ width: 13, height: 13 }} />
          </button>
        </div>

        {/* Options Feed */}
        <div className="bb-pdp-opt-list">
          {optionsList.map((variantItem, idx) => {
            const vId = String(variantItem.product_id || variantItem.id || variantItem._id || idx);
            const savedQty = bucketItemsMap?.get(vId)?.quantity;
            const bId = bucketItemsMap?.get(vId)?.bucketId;

            return (
              <ProductOptionCard
                key={vId}
                item={variantItem}
                customerId={customerId}
                hubId={hubId}
                purchaseType={purchaseType}
                bucketId={bId}
                savedBucketQuantity={savedQty}
                onAddSuccess={(addedItem) => {
                  if (onAddOption) onAddOption(addedItem);
                }}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}